module.exports = __webpack_public_path__ + "media/images/icons/material/arrow-left-8c3d7628c41878532f0c57f66791cee7.svg";